export const CAMPAIGN_SCHEDULE = {
  GGU: {
    endDate: '2025-07-16 15:00:00',
    timeZone: 'Asia/Singapore',
  },
  HALLOWEEN: {
    startDate: '2025-10-14 16:00:00',
    endDate: '2025-11-03 16:00:00',
    timeZone: 'Asia/Singapore',
  },
};
